import AboutPreview from "./AboutPreview";
import HeaderPreview from "./HeaderPreview";
import PortfolioPreview from "./PortfolioPreview";
import ContactPreview from "./ContactPreview";
import { Footer } from "../../components";
import ScrollButton from "../../components/ScrollButton";
import DownloadResume from "../about/DownloadResume";

const Mainpage = () => {
  document.title = "Nguyen Phuc Tien | Personal Portfolio";
  return (
    <article className="main-page">
      <HeaderPreview />
      {/* <DownloadResume className="gray-text p-tag"/> */}
      <AboutPreview />
      <PortfolioPreview />
      <ContactPreview />
      <ScrollButton />
      <Footer />
    </article>
  );
};

export default Mainpage;
